import {
	createPageSegmentLoadMetric,
	COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY,
	COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY,
	COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY,
	COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY,
} from '@confluence/browser-metrics';

const TIMINGS = [
	{
		key: 'fmp',
		endMark: 'fmp',
	},
	{
		key: 'tti',
		endMark: 'tti',
	},
	{
		key: 'viewRender',
		startMark: 'viewRenderStart',
		endMark: 'viewRenderEnd',
	},
];

export const COMMENTS_PANEL_OPEN_VIEW_METRIC = createPageSegmentLoadMetric({
	key: COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY,
	timings: TIMINGS,
});

export const COMMENTS_PANEL_UNREAD_VIEW_METRIC = createPageSegmentLoadMetric({
	key: COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY,
	timings: TIMINGS,
});

export const COMMENTS_PANEL_DELETED_CONTENT_VIEW_METRIC = createPageSegmentLoadMetric({
	key: COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY,
	timings: TIMINGS,
});

export const COMMENTS_PANEL_RESOLVED_VIEW_METRIC = createPageSegmentLoadMetric({
	key: COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY,
	timings: TIMINGS,
});
